import {Component, Input, OnInit} from '@angular/core';
import {NavigationExtras, Router} from "@angular/router";
import {UserService} from "../../../../../../user/user.service";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {Utils} from "../../../../../../shared/utils/utils";
import {DbValidators} from "../../../../../../shared/validators/DbValidators";
import {PluginConnectService} from "../../../../../../shared/services/plugin-connect/plugin-connect.service";
import {CookieService} from "ngx-cookie";
import {DbServerErrors} from "../../../../../../shared/interceptors/db-server-errors";
import {DbResponse} from "../../../../../../shared/interceptors/db-response";
import {AuthService} from "../../../../../../auth/auth.service";
import {TypeUtils} from "../../../../../../shared/utils/type-utils";
import {NotifierComponent} from "../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../shared/components/notifier/notification-type";
import {Config} from "../../../../../../config/config";
import {ReCaptchaV3Service} from "ngx-captcha";
import {filter, first} from "rxjs/operators";
import {UserSubscription} from "../../../../../../user/user-subscription";
import {CompanyInfo} from "../../../../../../store/actions/company-info.action";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../store';
import testimonialsList from "../../../../../../../assets/json/testimonials.json";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
import {BuilderHistoryService} from "../../../../../../builder-v2/builder-history.service";
import {BuilderV2Service} from "../../../../../../builder-v2/builder-v2.service";
import {BuilderSectionsInteractionService} from "../../../../../../builder-v2/builder-sections-interaction.service";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {DbTextPipe} from "../../../../../../shared/pipes/db-text.pipe";
import {
  LoadingCircularSpinnerComponent
} from "../../../../../../shared/components/loading-circular-spinner/loading-circular-spinner.component";
import {PasswordValidationComponent} from "../../../../../common/password-validation/password-validation.component";
import {TrustPilotComponent} from "../../../../../../shared/components/trustpilot/trustpilot.component";
import {GoogleAuthComponent} from "../../../../../../auth/google-auth/google-auth.component";
import {CheckoutService} from "../../../../../../auth/checkout/checkout.service";
import {GlobalEvent} from "../../../../../../shared/services/global-event-dispatcher/global-event";
import {
  GlobalEventDispatcherService
} from "../../../../../../shared/services/global-event-dispatcher/global-event-dispatcher.service";

@Component({
    selector: 'db-create-ai-assistant-sign-up',
    templateUrl: './create-ai-assistant-sign-up.component.html',
    styleUrls: ['./create-ai-assistant-sign-up.component.scss'],
    imports: [
        NgClass,
        NgIf,
        NgForOf,
        ReactiveFormsModule,
        DbTextPipe,
        LoadingCircularSpinnerComponent,
        PasswordValidationComponent,
        TrustPilotComponent,
        GoogleAuthComponent
    ]
})
export class CreateAiAssistantSignUpComponent implements OnInit {

  @Input() title: string;
  @Input() desc: string;
  @Input() steps: { description: string }[] = [];
  @Input() params: Record<string, string | number> = {};
  @Input() forSetup: boolean = false;
  @Input() fromEcommerce: boolean;
  @Input() v2Data: any;
  @Input() uniqueId: string;

  public isMobile: boolean = window.innerWidth <= 991;
  public loading: boolean;
  public googleBtnLoading: boolean;
  public enableRecaptcha: boolean;
  public serverErrors: DbServerErrors;
  public signUpForm: FormGroup;
  public subscription: UserSubscription;
  public answersData;
  public people: any = testimonialsList;
  public testimonialsCheckedId: number = 1;
  public userLocalStorage: any = {};
  public progress: number = 0;
  public showPassword: boolean = false;
  public emailChecked: boolean;
  public userDoesNotExist: boolean = false;
  public formSubmitted: boolean = false;
  public hasServerFieldErrors: boolean;
  public showPWDRequirements: boolean = false;
  public googleSignUpFormSubmitted: boolean;
  public invitedEmailAlreadyExist: boolean = false;
  public productId: number;
  public companyInfo: CompanyInfo;

  constructor(
    private _pluginConnectService: PluginConnectService,
    private _cookieService: CookieService,
    private _authService: AuthService,
    private _userService: UserService,
    private _router: Router,
    private _activeModal: DbActiveModal,
    private _reCaptchaV3Service: ReCaptchaV3Service,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _store: Store<fromStore.DbStoreState>,
    private _builderService: BuilderV2Service,
    private _builderHistoryService: BuilderHistoryService,
    private _builderInteractionsService: BuilderSectionsInteractionService,
    private _checkoutService: CheckoutService,
    private _globalEventDispatcher: GlobalEventDispatcherService
  ) {
    const navigation = this._router.getCurrentNavigation();
    const state = navigation?.extras?.state;

    if (state) {
      this.title = state['title'];
      this.desc = state['desc'];
      this.steps = state['steps'];
      this.v2Data = state['v2Data'];
      this.uniqueId = state['uniqueId'];
    }
  }

  ngOnInit() {
    /*window.addEventListener('beforeunload', this._handleUnload.bind(this));*/
    this._builderInteractionsService.setBackAction(() => {
      history.back();
    });
    if (localStorage.getItem('product_id')) {
      this.productId = parseInt(localStorage.getItem('product_id'), 10);
    }
    this.signUpForm = new FormGroup({
      'firstName': new FormControl('', [
        Validators.required,
        Utils.patternValidator(/[-a-zA-Z0-9@:%_+.~#?&\/=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&\/=]*)?/, {link: true}, true)
      ]),
      'lastName': new FormControl('', [
        Validators.required,
        Utils.patternValidator(/[-a-zA-Z0-9@:%_+.~#?&\/=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&\/=]*)?/, {link: true}, true)
      ]),
      'email': new FormControl('', [DbValidators.trim, Validators.required, Validators.email, Validators.pattern(/^[+_\-a-zA-Z0-9]+(\.[+_\-a-zA-Z0-9]+)*@[+_\-a-zA-Z0-9]+(\.[+_\-A-Za-z0-9]+)*(\.[+_\-A-Za-z]{2,24})$/)]),
      'password': new FormControl('',
        [Validators.required, Validators.minLength(8), DbValidators.trim,
          Utils.patternValidator(/\d/, {hasNumber: true}),
          Utils.patternValidator(/[A-Z]/, {hasCapitalCase: true}),
          Utils.patternValidator(/[a-z]/, {hasSmallCase: true})
        ]),
      /*'signUpFor': new FormControl(null, Validators.required),*/
      'subscriptionId': new FormControl(Config.basePlanId),
      'affiliate_id': new FormControl(this._cookieService.get('_fprom_track') || this._cookieService.get('idev')),
      'paymentMethod': new FormControl('stripe'),
      'plugin_id': new FormControl('')
    });
    this._sendGaEvent('pop-up opened');
    this._setAnswersData();
    this.recaptchaMode();
    this._store.select(fromStore.getCompanyInfo).pipe(filter(info => !!info), first()).subscribe(info => {
      this.companyInfo = info;
    });
  }

  private _setAnswersData(): void {
    this.answersData = {};
    this.answersData.Role = {
      "answer": "SMB",
      "id": "eLLnqwOWEyzs"
    };
    this.answersData.WebsiteNumber = {
      "answer": "1-3",
      "id": "EQ6sqoPuMvGg"
    };
    if (!this.forSetup) {
        this.answersData.LastChosenOption = {
          "answer": "ai-hosted-section",
          "id": ""
        };
    }
  }

  public blurEmail(direct = false): void {
    if (this.signUpForm.controls['email'].valid && (this.signUpForm.controls['email'].touched || direct)) {
      this._authService.checkUserExists(this.signUpForm.value.email)
        .pipe(filter((response: DbResponse): boolean => !!response),
          first())
        .subscribe((response) => {
          this.emailChecked = true;
          this.userDoesNotExist = !!response.success;
          if (direct && !response.success) {
            this.invitedEmailAlreadyExist = true;
          }
          if (response.success) {
            this.serverErrors = null;
          }
        });
    }
  }

  public onSignUpSubmit(): void {
    this.formSubmitted = true;
    this._sendGaEvent('Signup button click - Email');
    if (this.signUpForm.valid) {
      let recaptchaToken = null;
      this.loading = true;
      if (this.enableRecaptcha) {
        this._reCaptchaV3Service.execute(Config.googleRecaptcha, 'signup', (token) => {
          recaptchaToken = token;
          this.checkoutRequest(recaptchaToken, false);
        });
      } else {
        this.checkoutRequest(recaptchaToken, false);
      }
    }
  }

  public recaptchaMode(): void {
    this._authService.recaptchaEnv()
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response) => {
        if (response.success) {
          this.enableRecaptcha = response.data.recaptcha_mode.value === 'live';
        }
      });
  }

  private updateSignUpForData(): void {
    this._authService.updateSignUpFor(this.answersData, true)
      .pipe(
        first(response => !!response, null),
      )
      .subscribe(() => {
        this.updateUserLocalStorage();
      });
  }

  private updateUserLocalStorage(): void {

    this.loading = true;
    this.userLocalStorage['signUpFor'] = this.answersData;
    this._userService.setToLocal(this.userLocalStorage);
    if (!!this.forSetup) {
      this._redirectToOptions();
    }
  }

  private _redirectToOptions(): void {
    if (this.productId === Config.aiCreateWebsitePluginId) {
      localStorage.setItem('dbFromSetup', '1');
      setTimeout(() => {
        this.navigateTo('/setup/ai-convert');
      }, 1000);
    } else if (this.productId === Config.managerPluginId) {
      localStorage.setItem('dbFromMigrate', '1');
      setTimeout(() => {
        this.navigateTo('/setup/change-hosting');
      }, 1000);
    } else if (this.productId === Config.installBlankPluginId) {
      localStorage.setItem('dbFromBlank', '1');
      setTimeout(() => {
        this.navigateTo('/setup/install-blank');
      }, 1000);
    }
  }

  private navigateTo(url: string): void {
    this.loading = false;
    this._router.navigateByUrl(url).then((success) => {
      if (success) {
        this._activeModal.close();
      }
    });
  }

  public checkoutRequest(recaptchaToken, forceWebsiteCreate = false) {
    const getExperimentalCookie = this._cookieService.get('db-experiment');
    const trialHostedFlow = getExperimentalCookie ? (JSON.parse(getExperimentalCookie) && JSON.parse(getExperimentalCookie).trialFlowVersion ? +JSON.parse(getExperimentalCookie).trialFlowVersion : 0) : 0;
    const productId = localStorage.getItem('product_id') || (trialHostedFlow ? Config.aiBuilderPluginIds[Config.aiBuilderPluginIds.length - 1] : Config.builder2HostedPluginId);
    this._authService.checkout(this.signUpForm.value)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response) => {
        if (response.success) {
          this.loginAfterSignUp(response.data && response.data.manager_token, forceWebsiteCreate);
        } else if (response.serverErrors && TypeUtils.isEmpty(response.serverErrors.fields)) {
          NotifierComponent.notify(new Notification(response.serverErrors.message, NotificationType.DANGER, true));
          this.loading = false;
        } else {
          this.serverErrors = response.serverErrors;
          this.checkHasServerFieldErrors(response.serverErrors);
          this.loading = false;
        }
      });
  }

  private checkHasServerFieldErrors(serverErrors: DbServerErrors): void {
    this.hasServerFieldErrors = serverErrors && !!Utils.intersect(Object.keys(serverErrors.fields), ['name', 'first_name', 'last_name', 'email', 'password', 'stripe_token']).length;
  }

  private _sendGaEvent(label): void {
    const analyticsData = {
      eventCategory: 'Onboarding',
      eventAction: 'Sign-up form',
      eventLabel: label,
      isMobile: this.isMobile
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCoreWithoutUserData(analyticsData);
  }


  public loginAfterSignUp(managerOneTimeToken: string = "", forceWebsiteCreate = false): void {

    const loginData = {
      'email': this.signUpForm.value.email,
      'password': this.signUpForm.value.password,
    };

    if (this.enableRecaptcha) {
      let recaptchaToken;
      this._reCaptchaV3Service.execute(Config.googleRecaptcha, 'signup', (token) => {
        recaptchaToken = token;
        this.signUpLogin(loginData, managerOneTimeToken, forceWebsiteCreate, recaptchaToken);
      });
    } else {
      this.signUpLogin(loginData, managerOneTimeToken, forceWebsiteCreate, null);
    }

  }

  public signUpLogin(loginData, managerOneTimeToken, forceWebsiteCreate, recaptchaToken): void {
    this._authService.login(loginData, false, recaptchaToken)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response) => {
        if (response.success) {
          this.updateSignUpForData();
          this._userService.setToLocal({createdAfterUM: true});
          if (!this.forSetup) {
            this._activeModal.close('finalize');
          }
        } else {
          const navigationExtras: NavigationExtras = {
            queryParams: {userNotVerified: true}
          };
          this._router.navigateByUrl('/login', navigationExtras);
        }
      });
  }


  public signUpWithGoogle(googleToken): void {
    this.googleSignUpFormSubmitted = true;
    this.googleBtnLoading = true;
    localStorage.setItem('loadingGoogle', "1");
    localStorage.setItem('dbAnswersData', JSON.stringify(this.answersData));
    if (!this.forSetup) {
      !TypeUtils.isEmpty(this.params) && localStorage.setItem('dbStartAiParams', JSON.stringify(this.params));
      !!this.v2Data && localStorage.setItem('dbShowV2Finalize', '1');
    }
    this._sendGaEvent('Signup button click - Google');
    this._checkoutService.verifyGoogleToken(googleToken, this.signUpForm.controls['subscriptionId'].value, null, this.productId, null, this.signUpForm.controls['affiliate_id'].value, null)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response) => {
        if (response.success) {
          if (response.data && !response.data.agreement) {
            this._activeModal.close('existing');
            this._router.navigate(['/websites'], {
              queryParams: {
                forceCreateWebsite: true,
                fromGoogleSignIn: true,
                fromSignup: 1,
              }
            });
          } else {
            this.updateSignUpForData();
            this._userService.setToLocal({createdAfterUM: true});
            if (!this.forSetup) {
              this._activeModal.close('finalize');
            }
          }
          this.googleBtnLoading = false;
          this._globalEventDispatcher.dispatchEvent(GlobalEvent.userLogIn);
          this._store.dispatch(new fromStore.UserLogIn);
        } else {
          if (response.serverErrors && response.serverErrors.message !== "Client is not verified") {
            this.serverErrors = response.serverErrors;
            this.checkHasServerFieldErrors(response.serverErrors);
          }
          this.googleBtnLoading = false;
        }
      });
  }

  public progressPercent(): void {
    this.progress = Utils.progressPercent(this.signUpForm.controls['password']);
  }

  private _handleUnload() {
    this._builderHistoryService.resetSubjects();
    this._builderInteractionsService.resetSubjects();
    this._builderHistoryService.removeStateFromStorage();
  }

}
